<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Name" formControlName="name">
    <form-group-simple name="name" placeholder="Name"></form-group-simple>
  </form-group-context>

  <form-group-context label="Apple shared secret" formControlName="appleSharedSecret">
    <form-group-simple name="appleSharedSecret" placeholder="Apple shared secret"></form-group-simple>
  </form-group-context>

  <form-group-context label="Apple issuer id" formControlName="appleIssuerId">
    <form-group-simple name="appleIssuerId" placeholder="Issuer id"></form-group-simple>
  </form-group-context>

  <form-group-context label="Apple api key" formControlName="appleApiKey">
    <form-group-simple name="appleApiKey" placeholder="Api key"></form-group-simple>
  </form-group-context>

  <form-group-context label="P8" formControlName="appleP8">
    <form-group-simple type="textarea" name="appleP8" placeholder="P8"></form-group-simple>
  </form-group-context>

  <form-group-context label="Google email" formControlName="googleEmail">
    <form-group-simple name="googleEmail" placeholder="email"></form-group-simple>
  </form-group-context>

  <form-group-context label="googlePrivateKey" formControlName="googlePrivateKey">
    <form-group-simple type="textarea" name="googlePrivateKey" placeholder="google private key"></form-group-simple>
  </form-group-context>

  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
